module.exports = __webpack_public_path__ + "img/detractoresCara.6be37853.svg";